import { useSyncExternalStore } from 'react';

/** Set when ANY request returns 423 SYSTEM_LOCKED. Renders the full-screen "System locked" page. */
export interface LockState {
  locked: boolean;
  message: string;
}

let state: LockState = { locked: false, message: '' };
const listeners = new Set<() => void>();

export const lockStore = {
  getState: () => state,
  subscribe(l: () => void) {
    listeners.add(l);
    return () => listeners.delete(l);
  },
  lock(message: string) {
    state = { locked: true, message };
    listeners.forEach((l) => l());
  },
  unlock() {
    if (!state.locked) return;
    state = { locked: false, message: '' };
    listeners.forEach((l) => l());
  },
};

export function useLockState(): LockState {
  return useSyncExternalStore(lockStore.subscribe, lockStore.getState, lockStore.getState);
}
